import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';

declare let $: any;
declare let Swal:any;

@Component({
    selector : 'profile-screen',
    templateUrl:'profile-screen.html'
})
export class ProfileScreenComponent implements OnInit, OnDestroy{
  public admin=false;
  public images=[];
  public contact;
  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this._companyService.getUserByUid(this._appData.talkTo.uid).then(snap=>{
      this._appData.talkTo=snap.data();
      this._appData.talkTo.full_name=this._appData.talkTo.full_name.toUpperCase();
      //UPDATE MY USER PROFILE
      this._companyService.insertContact(this._appData.instagramUser,this._appData.talkTo,false);
      if (this._appData.talkTo.birthdate){
        let date=new Date(this._appData.talkTo.birthdate);
        let day=date.getDate()
        let strmonth=''
        let strday='';
        let month=date.getMonth()+1
        let year=date.getFullYear();
        if (month<10) {strmonth='0'+month} else {strmonth=month.toString();}
        if (day<10) {strday='0'+day} else {strday=day.toString();}
        this._appData.talkTo.birthdate=strday+'/'+strmonth+'/'+year.toString();
  
      }
      let galleryRefference=this._companyService.getUserGallery(this._appData.talkTo);
      galleryRefference.once('value').then((snapshot) =>{     
        let myimages=this.images;
        if (!myimages) myimages=[];
        let _messages=snapshot.val();
        for (let obj in _messages){
          this.images.unshift(_messages[obj]);             
        }
        //normal messages
      });
 
    })

  }
  public ngOnDestroy() : any {
  }

  public seePhoto(photo){
    Swal.fire({
      imageUrl: photo.url,
    })  
  }
  public openChat(){
    this._appData.talkTo=this._appData.talkTo;
    this._appData.cellScreen='chat'
    setTimeout(()=>{
      $('#cellChatReload').click()
    },1000)
  }


  public kick(){
    let contact=this._appData.talkTo;
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_5'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_6')+contact.full_name+'?',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},'Remoção',this._appData.instagramUser.full_name+' te removeu da sala.','kick',null,null)
      }
    })

  }
  public ban(){
    let contact=this._appData.talkTo;
    let admin=false;
    if (this._appData.event.admins){
      this._appData.event.admins.forEach((val)=>{
        if (val==this._appData.instagramUser.uid){
          admin=true;
          this._appData.instagramUser.vip=true;
        }
      }) 
    }
    if (admin){
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_7'),
        text:this.translate.instant('CONTACT_SCREEN_COMPONENT_8')+contact.full_name+'?',
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCancelButton: true,
        showCloseButton: true,
        preConfirm: () => {
          this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},'Banimento',this._appData.instagramUser.full_name+' te baniu da sala.','ban',null,null)
        }
      })  
    }
    else{
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_7'),
        text:this.translate.instant('CONTACT_SCREEN_COMPONENT_10')
      })  

    }

  }
  public yoink(){
    let contact=this._appData.talkTo;
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_12'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_11')+contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_9'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,contact,'Yoink',this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_13'),'Yoink',0,null)
      }

    })

  }
  public openConference(){
    let contact=this._appData.talkTo;
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_3'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_4'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,this.translate.instant('CONTACT_SCREEN_COMPONENT_21'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_22'),"newCellJitsi","",false)
        Swal.fire({
          title:this.translate.instant('CONTACT_SCREEN_COMPONENT_16'),
          message: contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_17')
        });
      }
    });       
  }
  public goto(){
    let contact=this._appData.talkTo;
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_15'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,this.translate.instant('CONTACT_SCREEN_COMPONENT_18'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_19'),"newCellTeleport",this._appData.event.id,false)
        Swal.fire({
          title:this.translate.instant('CONTACT_SCREEN_COMPONENT_16'),
          message: contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_17')
        });
      }
    });       
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/profile-screen/profile-screen.ts